import { render, staticRenderFns } from "./IncomeCorrect.vue?vue&type=template&id=a08d9978&scoped=true&"
import script from "./IncomeCorrect.vue?vue&type=script&lang=ts&"
export * from "./IncomeCorrect.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeCorrect.vue?vue&type=style&index=0&id=a08d9978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d9978",
  null
  
)

export default component.exports